<template src="../templates/uploads.html"></template>
<script>
    import axios from 'axios';
    import BForm from "bootstrap-vue/src/components/form/form";
    import BRow from "bootstrap-vue/src/components/layout/row";
    import BCol from "bootstrap-vue/es/components/layout/col";
    import Papa from "papaparse";

    export default {
        components: {BForm, BRow, BCol},
        name: 'UploadsComponent',
        data() {
            return {
                form: {
                    file: null,
                    email: "sa@yopmail.com",
                    emailIsValid: true,
                },
                fields: [],
                items: [],
                mappedItems: [],
                errors: [],
                dismissSecs: 60,
                dismissCountDown: 0,
                successDismissCountDown: 0,
                createdJobs: "",
                mappingField: [],
                fileHeader: [],
                tArray: [],
                jobData: [],
                confirmedMappedItems: [],
                dataObject: [],
                loading: false,
            };
        },
        created: function () {
            this.getMappingFields();
        },
        methods: {
            checkFile(file) {
                if (!file) {
                    return false;
                }
                let extension = file.name.split('.').pop();

                if (extension == 'csv') {
                    return true;
                } else {
                    return false;
                }

            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            },
            // validateEmail() {
            //     let re = /\S+@\S+\.\S+/;
            //     return re.test(String(this.form.email).toLowerCase());
            // },

            closeCsv() {
                this.jobData = [];
            },
            submitFile() {

                this.createdJobs = '';

                let formData = new FormData();

                if (this.form.file == null) {
                    return;
                }

                let extension = this.form.file.name.split('.').pop();
                if (extension != 'csv') {
                    return;
                }

                this.form.emailIsValid = true;

                formData.append('file', this.form.file);
                formData.append('email', this.form.email);

                /**Read the csv file**/
                const reader = new FileReader();
                /**A handler for the load event. This event is triggered each time the reading operation is successfully completed*/
                reader.onload = (e => {
                    console.log('e.target.result', e.target.result);
                    this.mapFields(e.target.result);
                });
                reader.readAsText(this.form.file);
            },
            filterJobsData() {
              console.log('this.mappingField.', this.mappingField);
                let languageMapping = this.mappingField.filter(m => m.field_name == 'language');
                console.log('languageMapping', languageMapping);
                let languageMapTo = languageMapping[0].map_to;
                let fileHeaderIndex = this.fileHeader.indexOf(languageMapTo);
                this.jobData = this.jobData.filter(m => m[fileHeaderIndex] != "");
            },
            mapFields(csvString) {

                this.fileHeader = [];
                this.tArray = [];
                this.jobData = [];
                this.confirmedMappedItems = [];

                this.jobData = Papa.parse(csvString).data;

                let rowArray = this.jobData;
                this.fileHeader = rowArray[0];
                // this.filterJobsData();
                for (let i = 0; i < this.fileHeader.length; i++) {
                    let fieldItem = this.mappingField.filter(m => m.map_to == this.fileHeader[i]);
                    if (fieldItem.length > 0) {
                        this.tArray.push({
                            file_field: this.fileHeader[i],
                            system_field: fieldItem[0].field_name,
                            order: fieldItem[0].order,
                            is_mapped: true
                        })
                    } else {
                        this.tArray.push({
                            file_field: this.fileHeader[i],
                            system_field: null,
                            order: null,
                            is_mapped: false
                        })
                    }
                }

                for (let j = 0; j < this.mappingField.length; j++) {
                    let fieldItem = this.tArray.filter(m => m.file_field == this.mappingField[j].map_to);

                    if (!(fieldItem.length > 0)) {
                        this.tArray.push({
                            file_field: null,
                            system_field: this.mappingField[j].field_name,
                            order: null,
                            is_mapped: false
                        })
                    }
                }


                let dataObject = Papa.parse(csvString, {header: true}).data;

                this.dataObject = dataObject;

                let mappedItems = this.tArray.filter(m => m.is_mapped == true);

                mappedItems.sort(function (a, b) {
                    return parseFloat(a.order) - parseFloat(b.order)
                });

                this.mappedItems = mappedItems;

                dataObject.forEach((item, index) => {
                    let jobObj = {};
                    for (let i = 0; i < mappedItems.length; i++) {
                        if (mappedItems[i].file_field in item) {
                            if (jobObj[mappedItems[i].system_field]) {
                                if (mappedItems[i].system_field == "comments") {
                                    jobObj[mappedItems[i].system_field] = jobObj[mappedItems[i].system_field] + '\n' + item[mappedItems[i].file_field];
                                } else {
                                    jobObj[mappedItems[i].system_field] = jobObj[mappedItems[i].system_field] + ', ' + item[mappedItems[i].file_field];
                                }

                            } else {
                                jobObj[mappedItems[i].system_field] = item[mappedItems[i].file_field];
                            }
                        }
                    }
                    this.confirmedMappedItems.push(jobObj);
                });

                /**If the supplied CSV file data is invalid, the confirmedMappedItems array could contain unwanted records,
                 * so below line of code will help to remove unwanted records from confirmedMappedItems array.*/
                this.confirmedMappedItems = this.confirmedMappedItems.filter(m => m.language != null && m.language != "");
                this.confirmedMappedItems = this.confirmedMappedItems.filter(m => m.appointment_date != null && m.appointment_date != "");

                this.replaceFieldValue();

            },
            replaceFieldValue() {
                this.confirmedMappedItems.forEach((item, index) => {
                    let keyList = Object.keys(item);

                    keyList.forEach((column, i) => {
                        // let fieldItem = this.mappingField.filter(m => m.field_name.toLowerCase() == column.toLowerCase());
                        let fieldItem = this.mappingField.filter(m => m.field_name == column);
                        let replaceFromList = [];
                        let replaceToList = [];

                        if (fieldItem[0].replace_from) {
                            replaceFromList = fieldItem[0].replace_from.split(',');
                        }

                        if (fieldItem[0].replace_to) {
                            replaceToList = fieldItem[0].replace_to.split(',');
                        }

                        if (replaceFromList.length > 0) {
                            var replaceIndex = replaceFromList.indexOf(this.confirmedMappedItems[index][column]);
                            this.confirmedMappedItems[index][column] = replaceToList[replaceIndex];
                        }
                    });
                });
            },
            isValidField(field, index) {
                let fieldItem = this.mappingField.filter(m => m.map_to == field);
                if (fieldItem[0]) {
                    return true;
                } else {
                    return false;
                }
            },
            resetForm(clearErrors = true) {
                this.form.file = null;
                this.form.email = "";
                this.form.emailIsValid = true;
                this.fields = [];
                this.items = [];
                this.createdJobs = '';
                this.mappedItems = [];
                this.fileHeader = [];
                this.tArray = [];
                this.jobData = [];
                this.confirmedMappedItems = [];

                if (clearErrors) {
                    this.errors = [];
                }
            },

            showNotification(message, type) {
              this.$v.$bvToast.toast(message, {
                title: "Notification",
                variant: type,
                solid: true,
              });
            },
            createJobs() {
                let url = this.$localApiURL + "import/jobs";
                let localThis = this;

                this.loading = true;

                console.log('localThis.confirmedMappedItems',localThis.confirmedMappedItems);

                axios({
                    method: 'post',
                    url: url,
                    headers: {'Bearer': localStorage.getItem('jwt')},
                    data: localThis.dataObject
                }).then(function (res) {

                    localThis.$notify({
                      title: "SUCCESS",
                      message: "Jobs are created",
                      type: "success",
                    });
                    localThis.loading = false;
                    localThis.resetForm();

                    if (res.data != null && res.data.result) {
                        localThis.createdJobs = "[" + res.data.refNumValues + "]";
                        localThis.successDismissCountDown = localThis.dismissSecs;
                    } else if (res.data.errors != null) {
                        localThis.errors = res.data.errors;
                        localThis.dismissCountDown = localThis.dismissSecs;
                    }

                }).catch(function (error) {
                    console.log(error);
                    localThis.loading = false

                    localThis.$notify({
                      title: "Error",
                      message: "Failed creating jobs",
                      type: "danger",
                    });
                });
            },
            getMappingFields() {
                let url = this.$localApiURL + "clients/mappingfield/get";
                let localThis = this;
                axios({
                    method: 'get',
                    url: url,
                    headers: {'Bearer': localStorage.getItem('jwt')},
                }).then(function (res) {
                    localThis.mappingField = res.data;
                }).catch(function (error) {
                    console.log(error);

                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UploadsComponent.vue